import { useMediaQuery } from "react-responsive";
import MainHome from "./MainHome";
import MainBusiness from "./MainBusiness";
import MainSolution from "./MainSolution";
import MainRecruit from "./MainRecruit";
import MainNews from "./MainNews";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Mousewheel, Pagination } from "swiper/modules";
import Footer from "./Footer";

//메인 원페이지 스크롤
function Main() {
  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  //스와이프
  const swiperName = ["HOME", "BUSINESS", "SOLUTION", "RECRUIT", "NEWS"];
  const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return (
        '<button class="slider-btn-list ' +
        className +
        '"><p class="slider-btn"></p><p class="slider-btn-title">' +
        swiperName[index] +
        "</p></button>"
      );
    }      
  };

  return (
    <>
      {pc ? (
        <div className="section-wrap">
          <Swiper
            direction={"vertical"}
            slidesPerView={1}
            mousewheel={true}
            autoHeight={true}
            pagination={pagination}            
            modules={[Mousewheel, Pagination]}
            speed={700}
            className="main-swiper"
          >
            <SwiperSlide>
              <section className="section main-home">
                <MainHome />
              </section>
            </SwiperSlide>
            <SwiperSlide>
              <section className="section main-business">
                <MainBusiness />
              </section>
            </SwiperSlide>
            <SwiperSlide>
              <section className="section main-solution">
                <MainSolution />
              </section>
            </SwiperSlide>
            <SwiperSlide>
              <section className="section main-recruit">
                <MainRecruit />
              </section>
            </SwiperSlide>
            <SwiperSlide>
              <section className="section main-news">
                <MainNews />
              </section>
              <Footer />
            </SwiperSlide>
          </Swiper>
        </div>
      ) : (
        <div>
          <section className="section main-home">
            <MainHome />
          </section>
          <section className="section main-business">
            <MainBusiness />
          </section>
          <section className="section main-solution">
            <MainSolution />
          </section>
          <section className="section main-recruit">
            <MainRecruit />
          </section>
          <section className="section main-news">
            <MainNews />
          </section>
          <Footer />
        </div>
      )}
    </>
  );
}

export default Main;
